// frontend/src/pages/FranchisingDettaglio.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TornaAlMenu from "../components/TornaAlMenu";

const API_URL = process.env.REACT_APP_API_URL || "";

function Row({ label, value }) {
  return (
    <div className="d-flex justify-content-between border-bottom py-2">
      <span className="text-muted">{label}</span>
      <strong className="text-break text-end" style={{ maxWidth: "65%" }}>
        {value || "-"}
      </strong>
    </div>
  );
}

export default function FranchisingDettaglio() {
  const { id } = useParams();
  const nav = useNavigate();

  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [data, setData] = useState(null);
  const [role, setRole] = useState("");
  const isMadre = role === "MADRE";

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setErr("");
        const token = localStorage.getItem("access");
        const headers = { Authorization: `Bearer ${token}` };

        const [meRes, res] = await Promise.all([
          fetch(`${API_URL}/api/me/`, { headers }),
          fetch(`${API_URL}/api/franchising/${id}/`, { headers }),
        ]);
        const me = await meRes.json().catch(() => ({}));
        setRole((me?.role || "").toUpperCase());

        const json = await res.json();
        if (!res.ok) throw new Error(json?.detail || "Errore caricamento franchising");
        setData(json);
      } catch (e) {
        setErr(e.message || "Errore");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  return (
    <div className="container mt-4">
      <TornaAlMenu to="/franchising" />
      <h2 className="mb-3">🏬 Dettaglio Franchising</h2>

      {err && <div className="alert alert-danger">{err}</div>}
      {loading ? (
        <p className="text-muted">Caricamento…</p>
      ) : !data ? (
        <div className="alert alert-info">Nessun dato da mostrare.</div>
      ) : (
        <>
          <div className="row g-3">
            <div className="col-lg-6">
              <div className="card shadow-sm h-100">
                <div className="card-header fw-semibold">Anagrafica</div>
                <div className="card-body">
                  <Row label="Codice" value={data.code} />
                  <Row label="Nome" value={data.name} />
                  <Row label="Referente" value={data.referent} />
                  <Row label="Indirizzo" value={data.address} />
                  <Row label="Telefono" value={data.telefono} />
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="card shadow-sm h-100">
                <div className="card-header fw-semibold">Account collegato</div>
                <div className="card-body">
                  <Row label="User ID" value={data.user_id} />
                  <Row label="Username" value={data.username} />
                  <Row label="Email" value={data.email} />
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="card shadow-sm h-100">
                <div className="card-header fw-semibold">Fatturazione</div>
                <div className="card-body">
                  <Row label="Ragione sociale" value={data.fatt_ragione_sociale} />
                  <Row label="Partita IVA" value={data.fatt_piva} />
                  <Row label="Codice Fiscale" value={data.fatt_cf} />
                  <Row label="Indirizzo" value={data.fatt_indirizzo} />
                  <Row label="CAP" value={data.fatt_cap} />
                  <Row label="Città" value={data.fatt_citta} />
                  <Row label="Provincia" value={data.fatt_provincia} />
                  <Row label="Nazione" value={data.fatt_nazione} />
                  <Row label="Email fatturazione" value={data.fatt_email} />
                  <Row label="PEC" value={data.fatt_pec} />
                  <Row label="SDI" value={data.fatt_sdi} />
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="card shadow-sm h-100">
                <div className="card-header fw-semibold">Amministrazione</div>
                <div className="card-body">
                  <Row label="IBAN" value={data.iban} />
                  <Row label="Banca" value={data.banca} />
                  <Row label="Note" value={data.note_admin} />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="card shadow-sm">
                <div className="card-header fw-semibold">KPI</div>
                <div className="card-body d-flex flex-wrap gap-3">
                  <div className="card border-0 shadow-sm" style={{ minWidth: 220 }}>
                    <div className="card-body">
                      <div className="text-muted small">Clienti</div>
                      <div className="display-6">{data.clienti_count ?? 0}</div>
                    </div>
                  </div>
                  <div className="card border-0 shadow-sm" style={{ minWidth: 220 }}>
                    <div className="card-body">
                      <div className="text-muted small">Agenti</div>
                      <div className="display-6">{data.agenti_count ?? 0}</div>
                    </div>
                  </div>
                  <div className="card border-0 shadow-sm" style={{ minWidth: 220 }}>
                    <div className="card-body">
                      <div className="text-muted small">Punti vendita</div>
                      <div className="display-6">{data.pv_count ?? 0}</div>
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex justify-content-end gap-2">
                  {isMadre && (
                    <button
                      className="btn btn-primary"
                      onClick={() => nav(`/franchising/${id}/edit`)}
                      title="Modifica franchising"
                    >
                      Modifica
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
